import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const MaintenanceCategorys = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default MaintenanceCategorys;
